// Forum (Reddit-style discussions).
export const forum: Record<string, string> = {
  'Forum': 'Forum',
  'CATEGORIES': 'KATEGORIJE',
  'All topics': 'Sve teme',
  'Discuss markets, strategies and ideas with other traders': 'Raspravljaj o tržištima, strategijama i idejama sa drugim trejderima',
  'New Topic': 'Nova tema',
  'Hot': 'Aktuelno',
  'New': 'Novo',
  'Top': 'Naj',
  'No topics yet': 'Još nema tema',
  'Be the first to start a discussion!': 'Budi prvi koji će pokrenuti diskusiju!',
  'comments': 'komentara',
  'Upvote': 'Glas za',
  'Downvote': 'Glas protiv',
  'Category': 'Kategorija',
  'Title': 'Naslov',
  'What do you want to discuss?': 'O čemu želiš da razgovaraš?',
  'Text (optional)': 'Tekst (opciono)',
  'Share details, context, your view…': 'Podeli detalje, kontekst, svoje viđenje…',
  'Ticker (optional)': 'Tiker (opciono)',
  'Publish': 'Objavi',
  'Publishing…': 'Objavljivanje…',
  'Title must be at least 4 characters': 'Naslov mora imati bar 4 znaka',
  'Topic not found': 'Tema nije pronađena',
  'Back to forum': 'Nazad na forum',
  'Delete topic': 'Obriši temu',
  'Delete this topic? This cannot be undone.': 'Obrisati ovu temu? Ovo se ne može poništiti.',
  'This topic is locked — new comments are disabled.': 'Ova tema je zaključana — novi komentari su onemogućeni.',
  'Write a comment…': 'Napiši komentar…',
  'Write a reply…': 'Napiši odgovor…',
  'Sign in to join the discussion': 'Prijavi se da se uključiš u diskusiju',
  'Comment': 'Komentariši',
  'Reply': 'Odgovori',
  'Replying below…': 'Odgovaraš ispod…',
  'No comments yet. Be the first!': 'Još nema komentara. Budi prvi!',
  'deleted': 'obrisano',

  // Edits, sorting, misc UX
  'Edit': 'Izmeni',
  'Save': 'Sačuvaj',
  'Saving…': 'Čuvanje…',
  'edited': 'izmenjeno',
  'Copy link': 'Kopiraj link',
  'Copied!': 'Kopirano!',
  'Share': 'Podeli',
  'More options…': 'Više opcija…',
  'Oldest': 'Najstarije',
  'Load more': 'Učitaj još',
  'Loading…': 'Učitavanje…',
  'Collapse replies': 'Skupi odgovore',
  'Expand replies': 'Proširi odgovore',
  'hidden': 'skriveno',
  'Something went wrong': 'Nešto je pošlo naopako',

  // Server error messages (shown through t() in the composers)
  'You are posting too fast — please wait a few minutes': 'Objavljuješ prebrzo — sačekaj par minuta',
  'You are posting too fast — please slow down': 'Objavljuješ prebrzo — uspori malo',
  'Thread is locked': 'Tema je zaključana',
  'Title too short': 'Naslov je prekratak',
  'Title too long': 'Naslov je predugačak',
  'Body too long': 'Tekst je predugačak',
  'Comment too long': 'Komentar je predugačak',
  'Empty comment': 'Prazan komentar',
  'Unknown category': 'Nepoznata kategorija',

  // Search, saved, reports, mentions, views
  'Search forum…': 'Pretraži forum…',
  'No results': 'Nema rezultata',
  'Try a different search term': 'Probaj drugi pojam za pretragu',
  'Saved topics': 'Sačuvane teme',
  'Saved': 'Sačuvano',
  'No saved topics yet': 'Još nema sačuvanih tema',
  'Save topics you want to find again — the bookmark is on every topic.': 'Sačuvaj teme koje želiš ponovo da nađeš — obeleživač je na svakoj temi.',
  'Report': 'Prijavi',
  'Reported': 'Prijavljeno',
  'Abusive': 'Uvredljivo',
  'Scam': 'Prevara',
  'Other': 'Ostalo',
  'mentioned you in': 'te pominje u',
  '— new comment in a topic you follow:': '— novi komentar u temi koju pratiš:',
  'Get notified about every new comment in this topic': 'Dobijaj obaveštenje za svaki novi komentar u ovoj temi',
  'Official AI account — posts are generated by artificial intelligence. Not financial advice.': 'Zvanični AI nalog — objave generiše veštačka inteligencija. Nije finansijski savet.',
  'Moderation': 'Moderacija',
  'Pin': 'Zakači',
  'Unpin': 'Otkači',
  'Lock': 'Zaključaj',
  'Unlock': 'Otključaj',

  // Image attachments
  'Add image': 'Dodaj sliku',
  'Uploading image…': 'Otpremanje slike…',
  'Image upload failed': 'Otpremanje slike nije uspelo',
  'You can attach up to 4 images': 'Možeš priložiti najviše 4 slike',
  'Up to 4 images (JPG, PNG, WebP, GIF, max 10MB)': 'Do 4 slike (JPG, PNG, WebP, GIF, najviše 10MB)',
  'Attached image': 'Priložena slika',
  'Remove image': 'Ukloni sliku',
  'Close': 'Zatvori',

  // Note: the pinned "Forum rules" thread used to be translated here via the
  // static dict. It's now translated like any other thread — titleSr/titleEn/
  // bodySr/bodyEn columns on ForumThread (see supabase/migrations/
  // 20260901120000_forum_translations.sql) — one mechanism, not two.

  // Category names + descriptions (stored in English in the DB)
  'General Discussion': 'Opšta diskusija',
  'Anything trading-related that fits nowhere else': 'Sve vezano za trejding što ne spada nigde drugde',
  'Analysis & Ideas': 'Analize i ideje',
  'Market analysis, setups and trade ideas': 'Analize tržišta, setapi i trejd ideje',
  'Strategies': 'Strategije',
  'Trading systems, risk management, psychology': 'Trejding sistemi, upravljanje rizikom, psihologija',
  'Currency pairs and macro': 'Valutni parovi i makro',
  'Bitcoin, altcoins and on-chain': 'Bitkoin, altkoini i on-chain',
  'Stocks & Indices': 'Akcije i indeksi',
  'Equities, ETFs and index trading': 'Akcije, ETF-ovi i trgovanje indeksima',
  'Beginners': 'Početnici',
  'No question is too basic': 'Nijedno pitanje nije previše osnovno',
  'Brokers & Tools': 'Brokeri i alati',
  'Brokers, platforms, charting and tooling': 'Brokeri, platforme, grafikoni i alati',
};
